import { render } from "./PollNodeEditor.vue?vue&type=template&id=5e8c43bc&ts=true"
import script from "./PollNodeEditor.vue?vue&type=script&lang=ts"
export * from "./PollNodeEditor.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__